var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1707",
    "data-name": "Group 1707",
    transform: "translate(-1732 -1025)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1419",
    "data-name": "Rectangle 1419",
    width: 46,
    height: 45,
    transform: "translate(1732 1025)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-picture-as-pdf",
    "data-name": "Icon material-picture-as-pdf",
    d: "M30,3H12A3.009,3.009,0,0,0,9,6V24a3.009,3.009,0,0,0,3,3H30a3.009,3.009,0,0,0,3-3V6A3.009,3.009,0,0,0,30,3ZM17.25,14.25A2.247,2.247,0,0,1,15,16.5H13.5v3H11.25v-9H15a2.247,2.247,0,0,1,2.25,2.25Zm7.5,3A2.247,2.247,0,0,1,22.5,19.5H18.75v-9H22.5a2.247,2.247,0,0,1,2.25,2.25Zm6-4.5H28.5v1.5h2.25V16.5H28.5v3H26.25v-9h4.5ZM13.5,14.25H15v-1.5H13.5Zm7.5,3h1.5v-4.5H21Z",
    transform: "translate(1734 1032)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.48b49ee323b64d9dbe18737f4861e50c.svg";
export { ForwardRef as ReactComponent };